// extracted by mini-css-extract-plugin
export default {"container":"Footer__container___lXwwp"};